import { IException } from '@augloop/schemas/dist/src/client/schemas';

export type LambdaType = string;

export type LambdaCallback<T> = (error?: Error | IException, result?: T) => void;

export const gatewayType = 'Gateway';
